var map = {
	"./apple2e": [
		1090,
		[
			90
		]
	],
	"./apple2e.ts": [
		1090,
		[
			90
		]
	],
	"./apple2enh": [
		6524,
		[
			524
		]
	],
	"./apple2enh.ts": [
		6524,
		[
			524
		]
	],
	"./apple2ex": [
		1664,
		[
			664
		]
	],
	"./apple2ex.ts": [
		1664,
		[
			664
		]
	],
	"./apple2j": [
		4619,
		[
			619
		]
	],
	"./apple2j.ts": [
		4619,
		[
			619
		]
	],
	"./fpbasic": [
		3419,
		[
			419
		]
	],
	"./fpbasic.ts": [
		3419,
		[
			419
		]
	],
	"./intbasic": [
		2418,
		[
			418
		]
	],
	"./intbasic.ts": [
		2418,
		[
			418
		]
	],
	"./original": [
		192,
		[
			192
		]
	],
	"./original.ts": [
		192,
		[
			192
		]
	],
	"./pravetz82": [
		9135,
		[
			135
		]
	],
	"./pravetz82.ts": [
		9135,
		[
			135
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4897;
module.exports = webpackAsyncContext;